import React from "react";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

function AddChapter({
  setSlicingEmptyObjects,
  setChapterPopup,
  novelData,
  setIndexOfChap,
  setAddChap,
  novelChaps,
}) {
  let titleRule = !novelData.title.length;
  let desRule = !novelData.description.length;
  let tagsRule = !novelData.tags.length;
  let imgRule = !novelData.selectedFile;

  function handleClick() {
    if (titleRule) {
      setChapterPopup(true);
      setTimeout(() => {
        setChapterPopup(false);
      }, 2000);
    } else if (desRule) {
      setChapterPopup(true);
      setTimeout(() => {
        setChapterPopup(false);
      }, 2000);
    } else if (tagsRule) {
      setChapterPopup(true);
      setTimeout(() => {
        setChapterPopup(false);
      }, 2000);
    } else if (imgRule) {
      setChapterPopup(true);
      setTimeout(() => {
        setChapterPopup(false);
      }, 2000);
    } else {
      novelChaps.push({
        createdAt: new Date(),
        // after submiting we do this line bellow
        chapterName: "",
        chapterBody: "",
      });
      setIndexOfChap(novelChaps.length - 1);
      setAddChap(true);
      setSlicingEmptyObjects(true);
    }
  }

  return (
    <div>
      <div onClick={handleClick} className="flex group  z-50 h-[52px] w-full">
        <div className="cursor-pointer group-hover:bg-tertiary/90 duration-500 ease-in-out w-[70%] sm:w-[70%] md:w-[80%] lg:w-[90%] h-full bg-tertiary flex justify-between items-center">
          <h2 className="capitalize px-4 md:px-8 text-[14px] sm:text-[16px]">
            Add Chapter {novelChaps.length + 1}
          </h2>
        </div>
        <div className="cursor-pointer w-[50%] sm:w-[30%] md:w-[20%] lg:w-[10%] flex space-x-2">
          <div className="w-full group-hover:bg-primary/90  duration-500 ease-in-out bg-primary flex justify-center items-center">
            <AiOutlinePlus className=" text-tertiary scale-125" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddChapter;
